<template>
  <div>
    <DefaultNotification
    v-if="isOpen"
    @update-card="updateCard"
    @openCard="$emit('openCard', $event)"
    @close-notification="closeNotification"
    @toggle-order="toggleOrder"
    @toggle-all="toggleAll"
      :title="notification.title"
      :expand-text="notification.expandText"
      :notificationSwitch="false"
      :doubleSwitchText="['Responsável', 'Oportunidade']"
      :cards="cards"
      :viewedCards="viewedCards"
    />
  </div>
</template>

<script>
import DefaultNotification from './NotificacaoPadrao.vue'
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'
import moment from 'moment'

export default {
  components: {
    DefaultNotification
  },
  data () {
    return {
      notification:
        {
          title: 'Notificações',
          expandText: 'Visualizados'
        },
      cards: [],
      viewedCards: [],
      data: [],
      isOpen: true,
      asc: true,
      all: false
    }
  },
  mounted () {
    this.retrieveNotifications()
  },
  methods: {
    closeNotification () {
      this.isOpen = false
    },
    formatDate (value) {
      if (value) {
        return moment(value).fromNow()
      }
      return null
    },
    retrieveNotifications () {
      this.getViewed()
      this.getNotViewed()
    },
    getViewed () {
      this.viewedCards = []
      let dataFilter = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `visualizado=true&sort=dataNotificiacao,${order}`
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              if (element.fromBoardColumn === this.all || (this.all === false && element.fromBoardColumn === null)) {
                let card = {
                  cardIcon: element.fromBoardColumn ? 'fas fa-bell' : 'fas fa-lightbulb',
                  cardIconText: this.formatDate(element.dataNotificiacao),
                  cardPersonPic: '',
                  cardTitle: element.card.nomePessoa,
                  cardDescription: element.card.boardColumn.board.nome ? element.card.boardColumn.board.nome : element.card.boardColumn.nome,
                  cardChecked: element.visualizado,
                  cardObj: element
                }
                dataFilter.push(card)
                this.viewedCards = dataFilter
              }
            })
          }
        })
        .catch(this.onException)
    },
    getNotViewed () {
      this.cards = []
      let dataFilter = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `visualizado=false&sort=dataNotificiacao,${order}`
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then(response => {
          if (response.data) {
            this.data = response.data.content
            this.data.forEach(element => {
              if (element.fromBoardColumn === this.all || (this.all === false && element.fromBoardColumn === null)) {
                let card = {
                  cardIcon: element.fromBoardColumn ? 'fas fa-bell' : 'fas fa-lightbulb',
                  cardIconText: this.formatDate(element.dataNotificiacao),
                  cardPersonPic: '',
                  cardTitle: element.card.nomePessoa,
                  cardDescription: element.card.boardColumn.board.nome ? element.card.boardColumn.board.nome : element.card.boardColumn.nome,
                  cardChecked: element.visualizado,
                  cardObj: element
                }
                dataFilter.push(card)
                this.cards = dataFilter
              }
            })
          }
        })
        .catch(this.onException)
    },
    updateCard (card) {
      this.retrieveNotifications()
    },
    toggleOrder () {
      this.asc = !this.asc
      this.retrieveNotifications()
    },
    toggleAll () {
      this.all = !this.all
      this.retrieveNotifications()
    }
  },
  emits: ['update-card', 'close-notification', 'toggle-all', 'toogle-order']
}
</script>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Oportunidades.vue